import { Button, Card, CardContent, Typography } from "@mui/material";
import styles from "./UserRegistration.module.css";
import SuccessImage from "../../images/Success.svg";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../routes/routes";

export const Status = () => {
    const navigate = useNavigate();
    const handleClick = () => navigate(Routes.HOME);

    return (
        <div className={styles.container}>
            <Card className={styles.card}>
                <CardContent>
                    <div className={styles.statusContainer}>
                        <img alt="Status Logo" src={SuccessImage} className={styles.successImage}/>
                        <div className={styles.statusLabelContainer}>
                            <Typography variant="h2" className={styles.header}>
                                {
                                    "Registration Successful"
                                }
                            </Typography>
                            <Typography variant="body2" className={styles.label}>
                                {"You are now logged in. Please click on the button below to go to homepage."}
                            </Typography>
                        </div>
                        <Button className={styles.closeBtn} onClick={handleClick}>Home</Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}